import React, { Component, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import '../../statics/stylesheet.css';

export default class PopUpContainer extends Component {
    static propTypes = {
        titleText: PropTypes.string.isRequired,
        infoText: PropTypes.string,
        buttonOneText: PropTypes.string.isRequired,
        buttonOneFunction: PropTypes.func.isRequired,
        buttonTwoText: PropTypes.string.isRequired,
        buttonTwoFunction: PropTypes.func.isRequired,
        isWarning: PropTypes.bool
    };

    render() {
        let { titleText, infoText, buttonOneText, buttonOneFunction, buttonTwoText, buttonTwoFunction, isWarning } = this.props;
        let color = (isWarning) ? '#C50000' : 'black';
        
        return (
            <div className="popUp-backgroundDiv">            
              <div className="popUp-InformationDiv">
                <div className="popUp-innerInformationDiv">
                    {(infoText) ? 
                        (<div className="popUp-stage3FontDiv">
                            <h2 className="content-titleFont">{titleText}</h2>
                            <p className="popUp-stage3InfoFont">{infoText}</p>
                        </div>
                    ) : (
                        <p className="content-titleFont">{titleText}</p>
                    )}                 
                    <div className="popUp-buttonDiv">
                       <button onClick={() => buttonOneFunction()} className="popUp-buttonStyle">{buttonOneText}</button>
                       <button onClick={() => buttonTwoFunction()} className="popUp-buttonStyle">{buttonTwoText}</button>
                    </div>
                </div>
               </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/subcomponents/PopUpContainer.js